
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';

@Component({})
export default class FollowsListModal extends Vue {
  visible = false;

  title = '回访记录';

  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  @Prop({ type: String, default: 'ordinary' })
  type!: string;

  record: any;

  timeline: any[] = [];

  async init(record: any) {
    this.record = record;
    if (this.type === 'ka') {
      const res = await this.customerFundingService.getSimpleFollows(this.record.id);
      if (res) {
        this.timeline = res;
        this.visible = true;
      }
    } else {
      const res = await this.customerFundingService.getAgentFollowList(this.record.id);
      if (res) {
        this.timeline = res;
        this.visible = true;
      }
    }
  }

  handleCancel() {
    this.visible = false;
  }
}

